import React, { useState, useEffect } from 'react';
import './style.scss';
import { FaQuoteLeft, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useLanguage } from '../../i18n';
import { getReviews } from '../../utils/content';

const testimonialsEn = [
    {
        name: 'Rajesh Kumar',
        role: 'Business Owner',
        location: 'New Delhi',
        rating: 5,
        text: 'Legal Corridor handled my commercial dispute with exceptional professionalism. Their strategic approach helped us reach a favorable settlement in record time. Highly recommend their corporate litigation services.',
        image: null
    },
    {
        name: 'Priya Sharma',
        role: 'IT Professional',
        location: 'Noida',
        rating: 5,
        text: 'During one of the most difficult times of my life, the family law team at Legal Corridor showed incredible compassion and expertise. They fought for my rights and my children with unwavering dedication.',
        image: null
    },
    {
        name: 'Mohammed Ali',
        role: 'Real Estate Developer',
        location: 'Gurgaon',
        rating: 5,
        text: 'The property law expertise at Legal Corridor is unmatched. They handled complex RERA matters for our projects and provided clear guidance through every legal challenge we faced.',
        image: null
    },
    {
        name: 'Sunita Verma',
        role: 'Entrepreneur',
        location: 'Delhi',
        rating: 5,
        text: 'Adv. Aman Verma and his team recovered our outstanding payments through strategic legal action. Their knowledge of cheque bounce cases and recovery laws is truly impressive.',
        image: null
    }
];

const testimonialsHi = [
    {
        name: 'राजेश कुमार',
        role: 'व्यापार मालिक',
        location: 'नई दिल्ली',
        rating: 5,
        text: 'लीगल कॉरिडोर ने मेरे वाणिज्यिक विवाद को असाधारण व्यावसायिकता के साथ संभाला। उनके रणनीतिक दृष्टिकोण ने हमें रिकॉर्ड समय में अनुकूल समझौते तक पहुंचने में मदद की। उनकी कॉर्पोरेट मुकदमेबाजी सेवाओं की अत्यधिक अनुशंसा करता हूं।',
        image: null
    },
    {
        name: 'प्रिया शर्मा',
        role: 'आईटी पेशेवर',
        location: 'नोएडा',
        rating: 5,
        text: 'मेरे जीवन के सबसे कठिन समय में से एक के दौरान, लीगल कॉरिडोर की पारिवारिक कानून टीम ने अविश्वसनीय करुणा और विशेषज्ञता दिखाई। उन्होंने अटूट समर्पण के साथ मेरे और मेरे बच्चों के अधिकारों के लिए लड़ाई लड़ी।',
        image: null
    },
    {
        name: 'मोहम्मद अली',
        role: 'रियल एस्टेट डेवलपर',
        location: 'गुड़गांव',
        rating: 5,
        text: 'लीगल कॉरिडोर की संपत्ति कानून विशेषज्ञता बेजोड़ है। उन्होंने हमारी परियोजनाओं के लिए जटिल रेरा मामलों को संभाला और हमारे सामने आने वाली हर कानूनी चुनौती के माध्यम से स्पष्ट मार्गदर्शन प्रदान किया।',
        image: null
    },
    {
        name: 'सुनीता वर्मा',
        role: 'उद्यमी',
        location: 'दिल्ली',
        rating: 5,
        text: 'अधिवक्ता अमन वर्मा और उनकी टीम ने रणनीतिक कानूनी कार्रवाई के माध्यम से हमारे बकाया भुगतान की वसूली की। चेक बाउंस मामलों और वसूली कानूनों का उनका ज्ञान वास्तव में प्रभावशाली है।',
        image: null
    }
];

const Testimonials = ({ className }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [apiReviews, setApiReviews] = useState(null);
    const { t, language } = useLanguage();

    useEffect(() => {
        getReviews().then((reviews) => {
            if (reviews.length > 0) setApiReviews(reviews);
        });
    }, []);

    const fallback = language === 'hi' ? testimonialsHi : testimonialsEn;
    const testimonials = apiReviews || fallback;

    const nextTestimonial = () => {
        setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    };

    const prevTestimonial = () => {
        setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    };

    const current = testimonials[currentIndex];

    return (
        <section className={`testimonialsArea ${className || ''}`}>
            <div className="container">
                <div className="sectionHeader">
                    <span className="subTitle">{t('testimonials.subtitle')}</span>
                    <h2>{t('testimonials.title')}</h2>
                </div>

                <div className="testimonialCard">
                    <div className="quoteIcon">
                        <FaQuoteLeft />
                    </div>

                    <div className="testimonialContent">
                        <div className="rating">
                            {[...Array(current.rating)].map((_, i) => (
                                <FaStar key={i} />
                            ))}
                        </div>

                        <p className="testimonialText">{current.text}</p>

                        <div className="clientInfo">
                            <div className="avatar">
                                {current.photo_url
                                    ? <img loading="lazy" decoding="async" src={current.photo_url} alt={current.name} />
                                    : current.name.charAt(0)
                                }
                            </div>
                            <div className="details">
                                <h5>{current.name}</h5>
                                <span>{current.role}, {current.location}</span>
                            </div>
                        </div>
                    </div>

                    <div className="navigation">
                        <button onClick={prevTestimonial} className="navBtn" aria-label="Previous">
                            <FaChevronLeft />
                        </button>
                        <div className="counter">
                            {currentIndex + 1} / {testimonials.length}
                        </div>
                        <button onClick={nextTestimonial} className="navBtn" aria-label="Next">
                            <FaChevronRight />
                        </button>
                    </div>
                </div>

                <div className="testimonialDots">
                    {testimonials.map((_, i) => (
                        <button
                            key={i}
                            className={`dot ${i === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(i)}
                            aria-label={`Go to testimonial ${i + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
